export default __webpack_public_path__ + "static/media/icon-X.ad17aee1.svg";